import React from 'react';
import classNames from 'classnames';
import styles from './InputTextarea.module.scss';

interface InputTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	label: string | React.ReactNode;
	hideLabel?: boolean;
	isSmall?: boolean;
	variant?: 'default' | 'inverse';
	errorText?: string;
	helperText?: string;
}

/**
 * Generic InputTextarea component, used for creating textarea. Has support for most props as InputText
 */
export const InputTextarea: React.FunctionComponent<InputTextareaProps> = ({
	className,
	id,
	label,
	hideLabel,
	isSmall,
	variant = 'default',
	disabled,
	required,
	errorText,
	helperText,
	...rest
}) => {
	return (
		<div
			className={classNames(
				styles.wrapper,
				{
					[styles.isDisabled]: disabled,
					[styles.isSmall]: isSmall,
					[styles.isInverse]: variant === 'inverse',
					[styles.hasError]: !!errorText?.length,
				},
				className,
			)}
		>
			<label
				className={classNames(styles.label, { [styles.required]: required }, hideLabel && 'u-hide-visually')}
				htmlFor={id}
			>
				{label}
			</label>

			<textarea
				className={classNames(styles.textarea)}
				id={id}
				disabled={disabled}
				required={required}
				{...rest}
			/>

			{helperText && <p className={styles.helperText}>{helperText}</p>}
			{errorText && <p className={styles.errorText}>{errorText}</p>}
		</div>
	);
};
